import { jsx as n } from "@emotion/react/jsx-runtime";
import { ProductIconV2 as e } from "@partoohub/iconography";
import { StyledImage as i, DEFAULT_PARTNER_LINK_ICON_SIZE as t } from "./BaseMenu.styled.js";
const I = ({
  route: o,
  isHovered: c,
  isActive: r = !1
}) => {
  const a = c || r;
  return o.type === "partnerLink" ? /* @__PURE__ */ n(i, { src: o.logoUrl, alt: o.alt, height: t, width: t }) : /* @__PURE__ */ n(e, { name: o.icon, isHovered: a, color: o?.color ?? "secondary", activeColor: o?.activeColor ?? "primary", active: r });
};
export {
  I as BaseMenuIcon
};
